<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container justify-content-end">
        <div class="button-container">
          <el-button
            :loading="isGeneratingCSV"
            type="warning"
            icon="el-icon-download"
            size="mini"
            @click="handleExportCSV">Export CSV</el-button>
        </div>
      </div>
    </template>

    <el-table
      v-loading="isLoading"
      :data="list"
      stripe
      border
      style="width: 100%">
      <el-table-column
        sortable
        prop="user_name"
        label="User Name"
        min-width="200"/>
      <el-table-column
        sortable
        prop="currency"
        label="Currency"
        min-width="50"/>
      <el-table-column
        sortable
        prop="actual_commission_usd"
        label="Amount (USD)"
        min-width="80"/>
      <el-table-column
        fixed="right"
        label="Action"
        align="center"
        width="120">
        <template slot-scope="scope">
          <el-button
            type="info"
            size="mini"
            icon="el-icon-document"
            @click="showOrderDetail(scope.row)">Order List</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :visible.sync="showOrderDetailModal"
      title="Order List">
      <el-table :data="selectedOrderDetail">
        <el-table-column
          prop="order_id"
          label="Order ID"
          min-width="100"/>
        <el-table-column
          prop="order_status"
          label="Order Status"
          min-width="100"/>
        <el-table-column
          prop="currency"
          label="Currency"
          min-width="80"/>
        <el-table-column
          prop="actual_commission_usd"
          label="Amount"
          width="100"/>
      </el-table>
    </el-dialog>

  </sticky-header-layout>
</template>

<script>
import { getPendingPayments, generatePendingPaymentsCsv } from '../../api/rewardsnap'
import fileDownload from '../../utils/file-download'

import useTablePaging from '../../mixins/useTablePaging'

export default {
  name: 'PendingPayment',
  mixins: [useTablePaging],
  data() {
    return {
      isLoading: false,
      isGeneratingCSV: false,
      showOrderDetailModal: false,
      selectedOrderDetail: null,
    }
  },
  computed: {
    canExportCSV() {
      return this.list.length > 0
    },
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await getPendingPayments()
        const newList = response.data;

        if (Array.isArray(newList)) {
          this.list = newList
        }

        this.isLoading = false
      } catch (error) {
        this.list = []
        this.isLoading = false
      }
    },
    showOrderDetail(record) {
      this.selectedOrderDetail = record.orders
      this.$nextTick(() => {
        this.showOrderDetailModal = true
      })
    },
    async handleExportCSV() {
      this.isGeneratingCSV = true
      try {
        const response = await generatePendingPaymentsCsv()
        const isCSV = response.headers['content-type'] === 'application/excel'
        const { data } = response
        this.isGeneratingCSV = false

        if (!isCSV) {
          this.$alert(data.data.message, 'Success', {
            confirmButtonText: 'OK',
            type: 'warning',
          })
          return
        }

        fileDownload(data, 'upcoming_payout.csv')
      } catch (error) {
        this.isGeneratingCSV = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>

